var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06078 4.69613L11.8893 7.52462L5.52528 13.8886H2.69678V11.0601L9.06078 4.69613ZM12.5963 2.57462L14.0103 3.98863C14.4008 4.37913 14.4008 5.01213 14.0103 5.40263L12.5963 6.81663L9.76778 3.98813L11.1818 2.57412C11.5723 2.18362 12.2053 2.18362 12.5958 2.57412L12.5963 2.57462Z",
    fill: "#94BE43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.6f3a19efc940d1dc0114b4917f955b6c.svg";
export { ForwardRef as ReactComponent };